import "./ThinkingProgress.css";
import { ProgressBar } from "@ui/ProgressBar.tsx";
import { TextMono } from "@ui/typography/TextMono";
import { Show } from "solid-js";
import type { LiveProgressState } from "../chatPanelState.ts";

export const ThinkingProgress = (props: { progress?: LiveProgressState }) => {
	const percentage = () => Math.round((props.progress?.percentage ?? 0) * 100);

	return (
		<Show when={props.progress}>
			<div class="thinking-progress">
				<Show when={props.progress?.description}>
					{(description) => (
						<TextMono as="span" class="thinking-progress__message" color="fg3">
							{description()}
						</TextMono>
					)}
				</Show>
				<div class="thinking-progress__bar">
					<ProgressBar value={percentage()} />
					<TextMono as="span" class="thinking-progress__percentage" color="fg3">
						{percentage()}%
					</TextMono>
				</div>
			</div>
		</Show>
	);
};
